import { Reveal, SectionLabel } from "./ui";
import RichHTML from "../RichHTML";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq({ faq = [], index, appr }) {
  return (
    <section style={appr?.style} className={`py-20 lg:py-28 ${appr?.dark ? "mf-section-dark" : ""}`}>
      <div className="mf-container grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <Reveal><SectionLabel index={index}>Häufige Fragen</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-head font-light tracking-tight text-[1.875em] lg:text-[2.6em] leading-tight mt-6 text-[var(--mf-ink)]">
              Klare Antworten <span className="font-medium">vorab</span>.
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal>
            <Accordion type="single" collapsible className="border-t border-[var(--mf-line)]">
              {faq.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-[var(--mf-line)]" data-testid={`faq-${i}`}>
                  <AccordionTrigger className="font-head font-semibold text-left text-[1.125em] text-[var(--mf-ink)] hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[var(--mf-ink-soft)] leading-relaxed text-[1em] pb-6">
                    <RichHTML html={f.a} />
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
